import { useState } from 'react';
import { buildAnswers, validate } from '../components/RefereeForm.utils';
import type { RefereeAnswer, RefereeQuestionForReferee } from '../types/referee-app.types';

export interface RefereeAnswersState {
  answers: Record<string, string>;
  errors: Record<string, string | undefined>;
  handleAnswerChange: (questionId: string, value: string) => void;
  validateAll: (questions: RefereeQuestionForReferee[]) => boolean;
}

export function useRefereeAnswers(initialAnswers: RefereeAnswer[]): RefereeAnswersState {
  const [answers, setAnswers] = useState<Record<string, string>>(buildAnswers(initialAnswers));
  const [errors, setErrors] = useState<Record<string, string | undefined>>({});

  const handleAnswerChange = (questionId: string, value: string): void => {
    setAnswers((prev) => ({ ...prev, [questionId]: value }));
    setErrors((prev) => ({ ...prev, [questionId]: undefined }));
  };

  const validateAll = (questions: RefereeQuestionForReferee[]): boolean => {
    const newErrors = validate(questions, answers);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return { answers, errors, handleAnswerChange, validateAll };
}
